/* eslint-disable import/extensions */
/* eslint-disable import/no-unresolved */
/* eslint-disable import/no-extraneous-dependencies */
import $ from 'jquery';
import pageLoadTime from 'instrumentation/pageLoadTime';

// TODO: Will remove after fully migrating to ResourceTimingV2
export const runPageLoadTime = (markName) => {
  $(window).load(() => {
    pageLoadTime.run();
    window.performance.mark(markName);
  });
};
